import { Component } from 'react';

import { FormattedMessage } from 'react-intl';

import styles from './CreditOutstanding.module.css';
import { CreditOutstandingMessage } from './creditOutstandingMessage/CreditOutstandingMessage';
import { MoneyWithDecimals } from '../../../ui/moneyWithDecimals/';

export class CreditOutstanding extends Component {
    renderAmount() {
        const { approvalStatusPrincipalBalance } = this.props;

        return (
            <span className={styles.amount}>
                <MoneyWithDecimals
                    decimalWithSeparatorClassName={styles.decimalsWithSeparator}
                    value={approvalStatusPrincipalBalance}
                />
            </span>
        );
    }

    renderDescription() {
        return (
            <div className={styles.description}>
                <FormattedMessage
                    id="_.dashboard.approved.credit_utilisation_outstanding_description"
                    defaultMessage="Credit outstanding"
                />
            </div>
        );
    }

    renderMessage() {
        const {
            approvalInterestRate,
            approvalStatusFeesBalance,
            approvalStatusInterestBalance,
            status
        } = this.props;

        return (
            <CreditOutstandingMessage
                className={styles.message}
                approvalInterestRate={approvalInterestRate}
                approvalStatusFeesBalance={approvalStatusFeesBalance}
                approvalStatusInterestBalance={approvalStatusInterestBalance}
                status={status}
            />
        );
    }

    render() {
        const amount = this.renderAmount();
        const description = this.renderDescription();
        const message = this.renderMessage();

        return (
            <div
                className={styles.CreditOutstanding}
                data-testid="credit-outstanding"
            >
                {amount}
                {description}
                {message}
            </div>
        );
    }
}
